import {
  transformDollarToPennies,
  transformPenniesToDollar,
} from 'src/utilities/currency-utils';

export const DEFAULT_MAX_CREDIT_CARD_CHARGE = 1000000;

interface InvoicePaymentMethodModel {
  invoicePaymentMethod: string;
  maxCreditCardCharge: number;
}

function getInvoicePaymentMethod(invoicePaymentMethod: string): string | null {
  return invoicePaymentMethod === '' || invoicePaymentMethod === 'None'
    ? null
    : invoicePaymentMethod;
}

function getMaxCreditCardCharge(
  invoicePaymentMethod: string,
  maxCreditCardCharge: number
): number | null {
  if (invoicePaymentMethod !== 'CREDIT_CARD_PRIMARY') {
    return DEFAULT_MAX_CREDIT_CARD_CHARGE;
  }

  return Number.isNaN(Number(maxCreditCardCharge))
    ? 0
    : transformDollarToPennies(Number(maxCreditCardCharge));
}

export const transformInvoicePaymentMethodUIToModel = ({
  invoicePaymentMethod,
  maxCreditCardCharge,
}: {
  invoicePaymentMethod;
  maxCreditCardCharge;
}): InvoicePaymentMethodModel => {
  return {
    invoicePaymentMethod: getInvoicePaymentMethod(invoicePaymentMethod),
    maxCreditCardCharge: getMaxCreditCardCharge(
      invoicePaymentMethod,
      maxCreditCardCharge
    ),
  };
};

export const transformInvoicePaymentMethodModelToUI = (
  maxCreditCardCharge: number
): string => {
  // Convert the input amount to string representation in dollars
  return transformPenniesToDollar(maxCreditCardCharge ?? 0);
};
